import { render, staticRenderFns } from "./PageReestr.vue?vue&type=template&id=d0f554a4"
import script from "./PageReestr.vue?vue&type=script&lang=js"
export * from "./PageReestr.vue?vue&type=script&lang=js"
import style0 from "./PageReestr.vue?vue&type=style&index=0&id=d0f554a4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports